<!-- 学生管理 -->
<template>
	<div class="fuzzy-matching-box">
		<div class="tongji">
			<el-row :gutter="70">
				<el-col :span="8">
					<el-text class="max-size">{{facetotal}}</el-text>
					<el-text class="min-size">总人数</el-text>
				</el-col>

				<el-col :span="8">
					<el-text class="max-size">{{faceCount}}</el-text>
					<el-text class="min-size">已录入人脸数</el-text>
				</el-col>

				<el-col :span="8">
					<el-text class="max-size">{{faceCount}}</el-text>
					<el-text class="min-size">人脸总数</el-text>
				</el-col>
			</el-row>
		</div>
		<!-- 学生管理 -->
		<div class="fuzzy-matching-top">
			<el-row class="top-first-line the-second-line">
				<el-col :span="5">
					<el-form-item label="姓名:">
						<el-input v-model="Dform.studentName" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="学号:">
						<el-input v-model="Dform.studentNo" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="imei:">
						<el-input v-model="Dform.imei" placeholder=''></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="top-first-line the-second-line">
				<el-col :span="5">
					<el-form-item label="学校:">
						<!-- <el-input v-model="Dform.schoolName" placeholder=''></el-input> -->
						<el-select v-model="schoolListTopId" placeholder="请选择学校" @change="schoolClickTop">
							<el-option :label="item.name" :value="item.id" v-for="item in schoolListTop"
								:key="item.name"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="年级:">
						<!-- <el-input v-model="Dform.gradeName" placeholder=''></el-input> -->
						<el-select v-model="gradeDataListTopId" placeholder="请选择年级" @change="classClickTop">
							<el-option :label="item.name" :value="item.id" v-for="item in gradeDataListTop"
								:key="item.name"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="班级:">
						<!-- <el-input v-model="Dform.className" placeholder=''></el-input> -->
						<el-select v-model="classListTopId" placeholder="请选择班级">
							<el-option :label="item.name" :value="item.id" v-for="item in classListTop"
								:key="item.name"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-button type="primary" size="medium" class="right query-button"
						@click="queryClick">查询</el-button>
					<el-button type="primary" size="medium" class="query-button" @click="batchImport">批量导入</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="fuzzy-matching-bottom">
			<el-row class="list">
				<el-table stripe :border="true" v-loading="loading"
					:header-cell-style="{ background: '#EDF6FF', color: '#000', }" ref="multipleTable" :data="tableData"
					tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column prop="studentName" label="姓名">
					</el-table-column>
					<el-table-column label="姓别" width="100">
						<template #default="scope">
							<span v-if="scope.row.sex == 0">{{ '女' }}</span>
							<span v-if="scope.row.sex == 1">{{ '男' }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="studentNo" label='学号'></el-table-column>
					<el-table-column prop="imei" label="imei" width="160"></el-table-column>
					<el-table-column prop="schoolName" label="学校"></el-table-column>
					<el-table-column prop="gradeName" label="年级"></el-table-column>
					<el-table-column prop="className" label="班级"></el-table-column>

					<el-table-column label="人脸图片" width="180">
						<template #default="scope">
							<img v-if="scope.row.facePic != null" :src="scope.row.facePic + `?${getTime()}`"
								@click="UpdataFaceClick(scope.row)" style="height: 40px; width: 30px;">
							<img src="../img/add-face.png" @click="selectFile(scope.row)"
								style="height: 30px; width: 30px" v-else>
							<input type="file" style="display: none" ref="fileInput" accept=".png, .jpg, .jpeg"
								@change="handleFileChange">
						</template>
					</el-table-column>
				</el-table>

				<div class="block">
					<div class="total"> 共<span class="texttiao">{{total}}</span>条记录，当前显示<span
							class="texttiao">{{ twigMin }}</span>到<span class="texttiao">{{ twigMax }}</span>条</div>
					<el-pagination :small="small" :disabled="disabled" :background="background"
						layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
						@current-change="handleCurrentChange" />
				</div>
			</el-row>
		</div>
		<UpdateStudentFaceView v-if="UpdataFace" @addClick="addClick" :titleValue="titleValue" :detailsObj="detailsObj">
		</UpdateStudentFaceView>
		<ManyStudentUpdateFace v-if="ShowManyFace" @addClick="addManyClick" :titleValue="titleValue">
		</ManyStudentUpdateFace>
	</div>
</template>
<script>
	import {
		schoolOrUserManagementList,
		studentjiechuRfid
	} from '@/assets/api/schoollog';
	import {
		importStudentInfo,
		importNfc,
		exportStudentInfo,
		studentDaoChuInfo,
		findStudentInfo,
		schoolOrUserinfoDelete,
		schoolList,
		gradeList,
		findClassList,
		getFaceStudentCount,
		uploadFace
	} from '@/assets/api/renyuan';

	import { UserFilled } from "@element-plus/icons-vue"; // 图标
	import { ElMessage,ElLoading } from 'element-plus'
	import UpdateStudentFaceView from './group/updateStudentFaceView.vue'
	import ManyStudentUpdateFace from './group/manyStudentUpdateFace.vue'
	import {getFace,addFace,updateFace,getBase64FromFilePath} from "@/assets/api/baiduApi"

	export default {
		components: {
			UserFilled,
			UpdateStudentFaceView,
			ManyStudentUpdateFace
		},
		data() {
			return {
				loading: true,
				ShowManyFace: false,
				faceCount: 0,
				facetotal: 0,
				Dform: {
					className: "",
					gradeName: "",
					schoolName: "",
					rfid: "",
					studentName: "",
					studentNo: "",
					imei: '',
					region: '',
					classes: '',
					classes2: '',
				},
				tableData: [

				],
				total: "",
				pageInfo: {
					pageSize: "10",
					page: "1",
				},
				theuserValue: 'ff245e1e-8347-4bd4-a714-88d6f0641c96',
				theuserList: [],
				tempFile: "", //文件
				titleValue: '',
				UpdataFace: false,
				detailsObj: {},
				Deviceidobj: {},
				schoolList: [],
				gradeDataList: [],
				classList: [],
				schoolListTopId: '',
				gradeDataListTopId: '',
				classListTopId: '',
				schoolListTop: [],
				gradeDataListTop: [],
				classListTop: [],
				twigMax: 0,
				twigMin: 0,
				itemData: {},
				elLoading : null
			};
		},
		created() {
			this.schoolOrUserManagementListSearch()
		},
		mounted() {
			this.schoolPost()
		},
		methods: {
			selectFile(item) {
				this.$refs.fileInput.click();
				this.itemData = item;
			},

			handleFileChange(event) {
				const file = event.target.files[0];
				const reader = new FileReader();
				reader.onload = (e) => {
					const dataURL = e.target.result;
					const targetSizeKB = 300; //图片大小限制
					this.compressH5(dataURL, targetSizeKB).then(file => {
						console.log('file 222 = ', file)
						const filePath = new File([file], Date.now() + ".jpeg", {
							type: file.type,
							lastModified: Date.now()
						});
						if (filePath) {
							//同步到百度人脸库
							this.getFace(this.itemData.studentId,filePath);
						}
						event.target.value = '';
					}).catch(err => {
						ElMessage.error("图片压缩异常")
					})
				};
				reader.readAsDataURL(file);
			},
			
		   	getFace(studentId,filePath){
				const param = {
					"group_id":"students",
					"user_id":studentId
				}
				
				this.openElLoading()
				getFace(param).then(async (res) => {
					if(res.data.error_code === 223103){ //人脸未注册
						const base64 = await getBase64FromFilePath(filePath);
						if(base64 != null){
							this.addFace(filePath,base64,studentId);
						}
					}else if(res.data.error_code === 0){ // 人脸已注册
						const base64 = await getBase64FromFilePath(filePath);
						if(base64 != null){
							this.updateFace(filePath,base64,studentId);
						} 
					}else{
						this.closeElLoading();
						ElMessage.error("人脸解析失败，请更换图片后重试")
					}
				}).catch((err) => {
					this.closeElLoading();
					ElMessage.error("人脸查找失败")
				})
			},
			
			addFace(filePath,image,studentId){
				const param = {
					"group_id":"students",
					"image":image,
					"image_type":"BASE64",
					"user_id":studentId,
				}
				addFace(param).then((res) => {
					if(res.data.error_code === 0){ //注册成功
						this.uploadFace(filePath,studentId)
					}else{
						this.closeElLoading();
						ElMessage.error("人脸注册失败") 
					}
				}).catch((err) => {
					this.closeElLoading();
					ElMessage.error("人脸注册失败")
				})
			},
			
			updateFace(filePath,image,studentId){
				const param = {
					"group_id":"students",
					"image":image,
					"image_type":"BASE64",
					"user_id":studentId,
				}
				updateFace(param).then((res) => {
					if(res.data.error_code === 0){ //更新成功
						this.uploadFace(filePath,studentId)
					}else{
						this.closeElLoading()
					 	ElMessage.error("人脸更新失败") 
					}
				}).catch((err) => {
					this.closeElLoading();
					ElMessage.error("人脸更新失败")
				})
			},
			
			uploadFace(filePath,studentId){
				let formData = new FormData();
				formData.append("file", filePath);
				formData.append("personId ", studentId);
				formData.append("personType", "1");
				formData.append("suffix", "jpeg");
				uploadFace(formData).then((res) => {
					console.log(res);
					this.closeElLoading();
					ElMessage.success("人脸上传成功！")
					this.schoolOrUserManagementListSearch()
				}).catch((err) => {
					this.closeElLoading();
					ElMessage.error("上传失败")
				})
			},
			
			openElLoading(){
				this.elLoading = ElLoading.service({
					lock: true,
					text: '图片上传中，请稍候...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			
			closeElLoading(){
				if(this.elLoading){
					this.elLoading.close();
					this.elLoading = null;
				}
			},
			
			compressH5(base64Str, targetSizeKB) {
				const maxQuality = 1.0;
				const minQuality = 0.0;
				const tolerance = 0.01; // 根据需要调整公差
				return new Promise((resolve, reject) => {
					const binarySearch = (min, max) => {
						const midQuality = (min + max) / 2;
						const img = new Image();
						img.src = base64Str;
						img.onload = function() {
							const canvas = document.createElement('canvas');
							const ctx = canvas.getContext('2d');

							let width = img.width;
							let height = img.height;
							while(width < 480 || width > 720){
								width = width / 4 * 3
								height = height / 4 * 3
							};
							
							canvas.width = Math.floor(width);
							canvas.height = Math.floor(height);

							ctx.clearRect(0, 0, canvas.width, canvas.height);
							ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

							// 使用异步的 toBlob 方法
							canvas.toBlob(async (blob) => {
								const fileSizeKB = blob.size / 1024;
								if (Math.abs(fileSizeKB - targetSizeKB) < tolerance || max -
									min < tolerance) {
									// 当前质量足够接近目标大小，使用当前质量解析
									resolve(blob);
								} else if (fileSizeKB > targetSizeKB) {
									// 如果文件大小太大，降低质量，继续二分查找
									binarySearch(min, midQuality);
								} else {
									// 如果文件大小太小，增加质量，继续二分查找
									binarySearch(midQuality, max);
								}
							}, 'image/jpeg', midQuality);
						};
					};

					// 开始二分查找
					binarySearch(minQuality, maxQuality);
				});
			},


			UpdataFaceClick(item) {
				this.detailsObj = item
				this.UpdataFace = true
			},

			schoolPost(schooName) {
				let params = JSON.parse(localStorage.getItem('user')).id;
				schoolList(params).then((res) => {
					console.log(res, '学校列表');
					this.schoolList = res.data.data
					this.schoolListTop = res.data.data
				}).catch((err) => {
					console.log(err);
				})
			},

			schoolClickTop() {
				this.gradeDataListTopId = ''
				this.classListTopId = ''
				// this.Dform.classes = ''
				// this.Dform.classes2 = ''
				this.gradeDataListTop = []
				this.classListTop = []
				let params = {
					page: '1',
					pageSize: '999',
				}
				gradeList(params, this.schoolListTopId).then((res) => {
					console.log(res, '年级列表');
					this.gradeDataListTop = res.data.data;
				}).catch((err) => {
					console.log(err);
				})
			},

			classClickTop() {
				this.classListTopId = ''
				// this.Dform.classes2 = ''
				this.classListTop = []
				let params = {
					page: '1',
					pageSize: '999',
				}
				findClassList(params, this.gradeDataListTopId).then((res) => {
					this.classListTop = res.data.data;
				}).catch((err) => {
					console.log(err);
				})
			},

			schoolClick() {
				this.Dform.classes = ''
				this.Dform.classes2 = ''
				this.gradeDataList = []
				this.classList = []
				let params = {
					page: '1',
					pageSize: '999',
				}
				gradeList(params, this.Dform.region).then((res) => {
					console.log(res, '年级列表');
					this.gradeDataList = res.data.data;
				}).catch((err) => {
					console.log(err);
				})
			},

			classClick() {
				this.Dform.classes2 = ''
				this.classList = []
				let params = {
					page: '1',
					pageSize: '999',
				}
				findClassList(params, this.Dform.classes).then((res) => {
					console.log(res, '班级列表');
					this.classList = res.data.data;
				}).catch((err) => {
					console.log(err);
				})
			},

			addClick() {
				this.UpdataFace = false
				this.schoolOrUserManagementListSearch()
				this.itemData = {};
			},

			addManyClick() {
				this.ShowManyFace = false
				this.schoolOrUserManagementListSearch()
			},

			schoolOrUserManagementListSearch() {
				const params = {
					// className: this.Dform.className,
					classId: this.classListTopId, // 班级
					rfidDecimal: this.Dform.rfid,
					// gradeName: this.Dform.gradeName,
					gradeId: this.gradeDataListTopId, // 年级
					// schoolName: this.Dform.schoolName,
					schoolId: this.schoolListTopId, // 学校
					studentName: this.Dform.studentName,
					studentNo: this.Dform.studentNo,
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
					imei: this.Dform.imei,
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				schoolOrUserManagementList(params).then((res) => {
					// console.log( res.data.data.list,'学生管理成功');
					this.tableData = res.data.data.list
					this.total = res.data.data.total
					this.loading = false
					let str = 0
					if (res.data.data.list.length < 10) {
						str = 10 - res.data.data.list.length
					}
					console.log(this.pageInfo.pageSize * this.pageInfo.page - 9, ']]]]]', this.pageInfo.pageSize *
						this.pageInfo.page - str);
					this.twigMin = this.pageInfo.pageSize * this.pageInfo.page - 9
					this.twigMax = this.pageInfo.pageSize * this.pageInfo.page - str

				}).catch((err) => {
					console.log(err, '学生管理失败');
				})

				getFaceStudentCount(params).then((res) => {
					this.faceCount = res.data.data.faceCount;
					this.facetotal = res.data.data.total
				}).catch((err) => {
					console.log(err, '获取人脸数量失败');
				})
			},

			queryClick() {
				this.schoolOrUserManagementListSearch()
			},

			batchImport() {
				this.titleValue = '批量导入'
				this.ShowManyFace = true
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},

			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.schoolOrUserManagementListSearch()
			},
			
			getTime(){
				return new Date().getTime();
			}
		},
	};
</script>

<style scoped lang="scss">
	.fuzzy-matching-box {
		padding-top: 20px;
		// overflow: hidden;
		// overflow: auto;
		width: 100%;
		height: 96%;
		background-color: #fff;
		border-radius: 8px;

		.tongji {
			width: 59%;
			margin-left: 60px;

			.el-col {
				text-align: center;
			}

			.el-text {
				display: block;
				background-color: #55aaff;
				color: white;
			}

			.max-size {
				font-weight: bold;
				padding-top: 10px;
				padding-bottom: 10px;
				font-size: 25px;

			}

			.min-size {
				padding-bottom: 10px;
				font-size: 15px;
				color: #666666;
			}
		}

		.query-button {
			margin: 2px;
			padding: 0px;
			font-size: 15px;
			font-weight: 700;
		}

		.title-top {
			padding: 20px 20px;
		}

		.fuzzy-matching-top {
			height: 130px;
			background-color: #fff;
			border-radius: 8px;

			.top-first-line {
				:deep() {
					.el-form-item--small .el-form-item__label {
						// background-color: red;
						font-size: 16px;
					}

					.el-select--small {
						width: 100%
					}

					.el-form-item--small .el-form-item__label {
						width: 110px;
						text-align: right;
						height: 35px;
						line-height: 35px;
						font-weight: 700;
					}

					.el-input {
						width: 100%;
						height: 35px;
					}

					.el-select--small .el-select__wrapper {
						height: 35px !important;
					}
				}

			}

			.the-second-line {
				margin-top: 15px;
				position: relative;

				.query-button {
					position: absolute;
					right: 300px;
					padding: 16px 24px;
				}

				.right {
					right: 450px;
				}

			}

			:deep() {
				.el-range-editor--small.el-input__wrapper {
					height: 35px;
					line-height: 35px;
				}


			}

		}

		.fuzzy-matching-content {
			height: 20px;
			line-height: 20px;
			margin-bottom: 10px;

			:deep() {
				.el-button {
					margin-left: 50px;
					font-size: 16px;

				}
			}
		}

		.block {
			display: flex;
			justify-content: center;
			text-align: center;
			font-size: 15px;
			margin-top: 10px;

			.sorter {
				margin-left: 50px;
			}

			.total {
				padding-top: 5px;
				margin-left: 800px;

			}

			.texttiao {
				color: #459FFC;

			}
		}

		.fuzzy-matching-bottom {
			// position: absolute;
			padding: 20px;

			.textButton {
				// background-color: pink;
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;
			}

			.tubiao {
				width: 12px;
			}

			.shanchuBtn {
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;
				color: red;
			}

			:deep() {
				.el-table th.el-table__cell>.cell {
					height: 30px;
					line-height: 30px;
					text-align: center;
					font-size: 16px;

				}

				.el-table td.el-table__cell div {
					text-align: center;
					height: 40px;
					line-height: 40px;
					border: 0;
					font-size: 16px;
					color: black;
				}

				.el-table:not(.el-table--border) .el-table__cell {
					// border: 0;
				}

				.el-button--small {
					margin: 0;
					padding: 0;
				}
			}

			.block-fenye {
				margin-left: 1000px;
				margin-top: 15px;
			}
		}

		.upload-box {
			margin-top: 15px;
			// line-height: 25px;

			:deep() {
				.el-select .el-input {
					height: 25px;
					margin-top: 0;
				}

				.el-form-item {
					margin-bottom: 0px !important;


				}

				.el-form-item__label {
					margin-left: 50px !important;

				}

			}

			.upload-lef {
				margin-left: 50px;
				font-size: 14px;

				.upload-title {}
			}

			.el-table tr {
				font-size: 20px;
			}

			:deep() {
				.el-button--small {
					height: 30px;
					margin-left: 100px;
					padding: 0px 25px;
				}

				.el-table--enable-row-transition .el-table__body td.el-table__cell {
					font-size: 40px;
				}

				// .el-form-item--small .el-form-item__content {
				//     height: 40px;
				//     line-height: 40px;
				// }
				.el-select .el-input__inner {
					height: 35px;
				}

				.el-form-item--small .el-form-item__label {
					margin-left: 20px;
					line-height: 28px;
				}

				.el-upload-list {
					// dis
					font-size: 80px;
				}

				.el-select--small .el-select__wrapper {
					width: 200px !important;
					// height: 35px !important;
				}
			}
		}
	}
</style>